var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-input",
            {
              staticClass: "filter-item",
              staticStyle: { width: "300px" },
              attrs: {
                placeholder: "Search by Name, Product ID, or Description",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleFilter.apply(null, arguments)
                },
              },
              model: {
                value: _vm.listQuery.search,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "search", $$v)
                },
                expression: "listQuery.search",
              },
            },
            [
              _c("el-button", {
                attrs: { slot: "append", icon: "el-icon-search" },
                on: { click: _vm.handleFilter },
                slot: "append",
              }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Platform", clearable: "" },
              on: { change: _vm.handleFilter },
              model: {
                value: _vm.listQuery.platform,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "platform", $$v)
                },
                expression: "listQuery.platform",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "General", value: "general" },
              }),
              _c("el-option", {
                attrs: { label: "Android", value: "android" },
              }),
              _c("el-option", { attrs: { label: "iOS", value: "ios" } }),
              _c("el-option", {
                attrs: { label: "External", value: "external" },
              }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Status", clearable: "" },
              on: { change: _vm.handleFilter },
              model: {
                value: _vm.listQuery.isActive,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "isActive", $$v)
                },
                expression: "listQuery.isActive",
              },
            },
            [
              _c("el-option", { attrs: { label: "Active", value: "true" } }),
              _c("el-option", { attrs: { label: "Inactive", value: "false" } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v(" Add Product ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.getList },
            },
            [_vm._v(" Refresh ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            data: _vm.products,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "Name", align: "left", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _c("strong", [_vm._v(_vm._s(row.name))]),
                      row.description
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                                "margin-top": "4px",
                              },
                            },
                            [_vm._v(" " + _vm._s(row.description) + " ")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Platform", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: _vm.getPlatformType(row.platform) } },
                      [_vm._v(" " + _vm._s(row.platform) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Product ID", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "12px",
                          "font-family": "monospace",
                        },
                      },
                      [_vm._v(_vm._s(row.productId))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Base Plan / Offer",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticStyle: { "font-size": "12px" } }, [
                      row.basePlanId
                        ? _c("div", [
                            _c("strong", [_vm._v("Plan:")]),
                            _vm._v(" " + _vm._s(row.basePlanId) + " "),
                          ])
                        : _vm._e(),
                      row.offerId
                        ? _c("div", [
                            _c("strong", [_vm._v("Offer:")]),
                            _vm._v(" " + _vm._s(row.offerId) + " "),
                          ])
                        : _vm._e(),
                      !row.basePlanId && !row.offerId
                        ? _c("span", { staticStyle: { color: "#909399" } }, [
                            _vm._v("N/A"),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Source Type", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getSourceTypeTag(row.sourceType),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatSourceType(row.sourceType)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Features", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                      _vm._v(
                        " " + _vm._s(row.featureGrants.length) + " grant(s) "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "App Display", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.showInApp
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [
                                _c("i", {
                                  staticClass: "el-icon-mobile-phone",
                                }),
                                _vm._v(" Shown "),
                              ]
                            ),
                            row.displayOrder !== null
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#909399",
                                      "margin-top": "2px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Order: " +
                                        _vm._s(row.displayOrder) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [_vm._v("Hidden")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Region", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.region
                      ? _vm._l(row.region.split(","), function (r) {
                          return _c(
                            "el-tag",
                            {
                              key: r,
                              staticStyle: { margin: "2px" },
                              attrs: { size: "small" },
                            },
                            [_vm._v(_vm._s(r.trim()))]
                          )
                        })
                      : _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("All"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.isActive ? "success" : "danger",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(row.isActive ? "Active" : "Inactive") +
                                " "
                            ),
                          ]
                        ),
                        row.isTest
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "4px" } },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "mini" } },
                                  [_vm._v("TEST")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              align: "center",
              width: "220",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "info",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleTest(row)
                          },
                        },
                      },
                      [_vm._v(" Test ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "danger",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v(" Delete ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogStatus === "create" ? "Create Product" : "Edit Product",
            visible: _vm.dialogFormVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "e.g., Android Premium Monthly" },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Brief description of this product",
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Platform", prop: "platform" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select platform" },
                      model: {
                        value: _vm.formData.platform,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "platform", $$v)
                        },
                        expression: "formData.platform",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "General (All Platforms)",
                          value: "general",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "Android", value: "android" },
                      }),
                      _c("el-option", {
                        attrs: { label: "iOS", value: "ios" },
                      }),
                      _c("el-option", {
                        attrs: { label: "External", value: "external" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Product ID", prop: "productId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "e.g., wewalk_premium_monthly" },
                    model: {
                      value: _vm.formData.productId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "productId", $$v)
                      },
                      expression: "formData.productId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Base Plan ID" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Optional (Android only)" },
                    model: {
                      value: _vm.formData.basePlanId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "basePlanId", $$v)
                      },
                      expression: "formData.basePlanId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Offer ID" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Optional (Android only)" },
                    model: {
                      value: _vm.formData.offerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "offerId", $$v)
                      },
                      expression: "formData.offerId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Source Type", prop: "sourceType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select source" },
                      model: {
                        value: _vm.formData.sourceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "sourceType", $$v)
                        },
                        expression: "formData.sourceType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "App Store Purchase (iOS)",
                          value: "app_store_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Google Play Purchase (Android)",
                          value: "google_play_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Subscription Purchase (Generic)",
                          value: "subscription_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Zoho Purchase",
                          value: "zoho_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "Admin Grant", value: "admin_grant" },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Device Connection",
                          value: "device_connection",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Coupon Redemption",
                          value: "coupon_redemption",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Referral Bonus",
                          value: "referral_bonus",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "Other", value: "other" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Feature Grants", prop: "featureGrants" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.addFeatureGrant },
                    },
                    [_vm._v(" Add Feature Grant ")]
                  ),
                  _vm._l(_vm.formData.featureGrants, function (grant, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "feature-grant-item" },
                      [
                        _c(
                          "el-card",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { shadow: "hover" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                  "align-items": "center",
                                },
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("span", [
                                  _vm._v("Feature Grant " + _vm._s(index + 1)),
                                ]),
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFeatureGrant(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "Feature Key" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      "allow-create": "",
                                      placeholder: "Select or type feature key",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onFeatureKeyChange(grant)
                                      },
                                    },
                                    model: {
                                      value: grant.feature_key,
                                      callback: function ($$v) {
                                        _vm.$set(grant, "feature_key", $$v)
                                      },
                                      expression: "grant.feature_key",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "WeAssist (Consult Time)",
                                        value: "weassist",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Voice Assistant",
                                        value: "voice_assistant",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Smart Map",
                                        value: "smart_map",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Navigation Plus",
                                        value: "navigation_plus",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "Duration Type" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "Select" },
                                    model: {
                                      value: grant.duration_type,
                                      callback: function ($$v) {
                                        _vm.$set(grant, "duration_type", $$v)
                                      },
                                      expression: "grant.duration_type",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "Permanent",
                                        value: "permanent",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Days", value: "days" },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Months",
                                        value: "months",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Years", value: "years" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            grant.duration_type !== "permanent"
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "Duration Value" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: { min: 1 },
                                      model: {
                                        value: grant.duration_value,
                                        callback: function ($$v) {
                                          _vm.$set(grant, "duration_value", $$v)
                                        },
                                        expression: "grant.duration_value",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            grant.feature_key === "weassist"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Consult Time (seconds)" },
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "200px" },
                                      attrs: { min: 0, step: 60 },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onWeassistSecondsChange(
                                            grant
                                          )
                                        },
                                      },
                                      model: {
                                        value: grant.weassistSeconds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            grant,
                                            "weassistSeconds",
                                            $$v
                                          )
                                        },
                                        expression: "grant.weassistSeconds",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "10px",
                                          color: "#909399",
                                          "font-size": "12px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatSecondsToTime(
                                                grant.weassistSeconds
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "#909399",
                                          "margin-top": "5px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " Example: 3600 = 1 hour, 1800 = 30 minutes "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            grant.feature_key !== "weassist"
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "Metadata (JSON)" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: 2,
                                        placeholder: '{"tier": "premium"}',
                                      },
                                      model: {
                                        value: grant.metadataString,
                                        callback: function ($$v) {
                                          _vm.$set(grant, "metadataString", $$v)
                                        },
                                        expression: "grant.metadataString",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Product Metadata" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder:
                        '{"category": "subscription", "renewalType": "monthly"}',
                    },
                    model: {
                      value: _vm.formData.metadataString,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "metadataString", $$v)
                      },
                      expression: "formData.metadataString",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "isActive", $$v)
                      },
                      expression: "formData.isActive",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "Region" } }, [
                _c(
                  "div",
                  { staticClass: "region-tag-input" },
                  [
                    _vm._l(_vm.regionTags, function (tag) {
                      return _c(
                        "el-tag",
                        {
                          key: tag,
                          staticStyle: {
                            "margin-right": "4px",
                            "margin-bottom": "4px",
                          },
                          attrs: { closable: "", size: "small" },
                          on: {
                            close: function ($event) {
                              return _vm.removeRegionTag(tag)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tag) + " ")]
                      )
                    }),
                    _c("el-input", {
                      staticClass: "region-inline-input",
                      attrs: {
                        placeholder: "Type code + Enter",
                        size: "small",
                        maxlength: "10",
                      },
                      nativeOn: {
                        keyup: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.addRegionTag.apply(null, arguments)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              $event.keyCode !== 188
                            )
                              return null
                            return _vm.addRegionTag.apply(null, arguments)
                          },
                        ],
                      },
                      model: {
                        value: _vm.regionInput,
                        callback: function ($$v) {
                          _vm.regionInput = $$v
                        },
                        expression: "regionInput",
                      },
                    }),
                  ],
                  2
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#909399", "font-size": "12px" } },
                  [
                    _vm._v(
                      " Press Enter or comma to add. Leave empty for all regions. "
                    ),
                  ]
                ),
              ]),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Mobile App Display Settings"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Show in App" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.showInApp,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "showInApp", $$v)
                      },
                      expression: "formData.showInApp",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#909399",
                        "font-size": "12px",
                      },
                    },
                    [
                      _vm._v(
                        " Enable to show this product in mobile app package list "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.formData.showInApp
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Package Code", prop: "code" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "e.g., wewalk_premium_monthly",
                          },
                          model: {
                            value: _vm.formData.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "code", $$v)
                            },
                            expression: "formData.code",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              "margin-top": "5px",
                            },
                          },
                          [
                            _vm._v(
                              " Unique identifier for this package in the app "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Title" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "Display title in the app" },
                          model: {
                            value: _vm.formData.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "title", $$v)
                            },
                            expression: "formData.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Button Text" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "e.g., Subscribe, Buy Now" },
                          model: {
                            value: _vm.formData.buttonText,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "buttonText", $$v)
                            },
                            expression: "formData.buttonText",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Package Type" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "Select type",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.packageType,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "packageType", $$v)
                              },
                              expression: "formData.packageType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: "Monthly Subscription",
                                value: "monthly",
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: "Yearly Subscription",
                                value: "yearly",
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: "Monthly Consult",
                                value: "monthly-consult",
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: "Additional Consult",
                                value: "additional-consult",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Display Order" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "150px" },
                          attrs: { min: 0, max: 999 },
                          model: {
                            value: _vm.formData.displayOrder,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "displayOrder", $$v)
                            },
                            expression: "formData.displayOrder",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              color: "#909399",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(" Lower numbers appear first ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Price" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "150px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            placeholder: "Amount",
                          },
                          model: {
                            value: _vm.formData.priceAmount,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "priceAmount", $$v)
                            },
                            expression: "formData.priceAmount",
                          },
                        }),
                        _c("el-input", {
                          staticStyle: { width: "80px", "margin-left": "10px" },
                          attrs: { placeholder: "USD", maxlength: "3" },
                          model: {
                            value: _vm.formData.priceCurrency,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "priceCurrency", $$v)
                            },
                            expression: "formData.priceCurrency",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "First Subscription" } },
                      [
                        _c("el-switch", {
                          model: {
                            value: _vm.formData.isFirstSubscription,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "isFirstSubscription", $$v)
                            },
                            expression: "formData.isFirstSubscription",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              color: "#909399",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(" Mark as first-time subscription offer ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Test Package" } },
                      [
                        _c("el-switch", {
                          model: {
                            value: _vm.formData.isTest,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "isTest", $$v)
                            },
                            expression: "formData.isTest",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              color: "#909399",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(" Only visible to test users ")]
                        ),
                      ],
                      1
                    ),
                    _vm.formData.isTest
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "Test Users" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 2,
                                placeholder: "Comma-separated email addresses",
                              },
                              model: {
                                value: _vm.formData.testUsers,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "testUsers", $$v)
                                },
                                expression: "formData.testUsers",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogStatus === "create"
                        ? _vm.createProduct()
                        : _vm.updateProduct()
                    },
                  },
                },
                [_vm._v(" Confirm ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Test Product Resolution",
            visible: _vm.testDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.testDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "140px" } },
            [
              _c("el-form-item", { attrs: { label: "Product" } }, [
                _c("strong", [_vm._v(_vm._s(_vm.testProduct?.name))]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Base Plan ID" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Optional override" },
                    model: {
                      value: _vm.testData.basePlanId,
                      callback: function ($$v) {
                        _vm.$set(_vm.testData, "basePlanId", $$v)
                      },
                      expression: "testData.basePlanId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Offer ID" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Optional override" },
                    model: {
                      value: _vm.testData.offerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.testData, "offerId", $$v)
                      },
                      expression: "testData.offerId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.testResult
            ? _c(
                "div",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c("el-divider", [_vm._v("Test Result")]),
                  _c("el-alert", {
                    attrs: {
                      type: _vm.testResult.resolved ? "success" : "error",
                      title: _vm.testResult.resolved
                        ? "Product Resolved Successfully"
                        : "Resolution Failed",
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _vm.testResult.product
                    ? _c("div", { staticStyle: { "margin-top": "20px" } }, [
                        _c(
                          "pre",
                          {
                            staticStyle: {
                              background: "#f5f7fa",
                              padding: "10px",
                              "border-radius": "4px",
                              "font-size": "12px",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                JSON.stringify(_vm.testResult.product, null, 2)
                              )
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.testDialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.runTest } },
                [_vm._v("Run Test")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }